import { IAppNavigationUIRoute } from "@tnwinc/navex-react"
import { pascalize } from "../../../Utils/utils"
import { computeDatasetManagementDefinitions } from './datasetManagementScreenDefinitions'
import { IDatasetManagementScreenDefinition } from './datasetManagementScreenTypes'
import { IFeatureConfigurations, IPowerBiReports } from "../../../Models/GlobalState"

export interface IDatasetManagementLeftNavTree {
    permissions: string[],
    unrecognizedPermissions: string[],
    accessibleScreens: {
        screenName: string,
        becauseOfPermission: string
    }[],
    inaccessibleScreens: string[],
    datasetManagementNodes: IAppNavigationUIRoute[]
}

const makeStartingAccumulator = (permissions: string[]): IDatasetManagementLeftNavTree => {
    return {
        permissions,
        unrecognizedPermissions: [],
        accessibleScreens: [],
        inaccessibleScreens: [],
        datasetManagementNodes: []
    }
}

interface IStringToAnyHash {
    [key: string]: any
}

export const computeDatasetManagementLeftNavNodes = (permissions: string[], toggles: string[], featureConfigurations: IFeatureConfigurations[], reportsLeftNavMenu: IPowerBiReports[]): IDatasetManagementLeftNavTree => {
    const unrecognizedPermissionsHash: IStringToAnyHash = permissions.reduce((acc: IStringToAnyHash, p) => {
        acc[p] = 42
        return acc
    },
        {})

    const features = Array.isArray(featureConfigurations) ? featureConfigurations.map(f => f.featureConfigurationName) : []
    const datasetManagementScreenDefinitions = computeDatasetManagementDefinitions(features,toggles, reportsLeftNavMenu)

    const result = Object.keys(datasetManagementScreenDefinitions).reduce(
        (acc: IDatasetManagementLeftNavTree, screenName: string) => {
            const screenDefinition = datasetManagementScreenDefinitions[screenName]
            const nameOfGetingPermission = screenDefinition.getingPermission || `${screenName}Get`
            const nameOfToggle = screenDefinition.toggleName
            const isToggleEnabled = !nameOfToggle ? true : toggles.includes(nameOfToggle)

            recognizePermission(nameOfGetingPermission)

            if (isToggleEnabled && permissions.includes(nameOfGetingPermission)) {
                acc.accessibleScreens.push({
                    screenName, becauseOfPermission: nameOfGetingPermission
                })
                acc.datasetManagementNodes.push(makeDatasetManagementNode(screenDefinition))
            }
            else {
                acc.inaccessibleScreens.push(screenName)
            }

            return acc
        },
        makeStartingAccumulator(permissions)
    )

    result.unrecognizedPermissions = Object.keys(unrecognizedPermissionsHash) || []

    return result

    function recognizePermission(permissionName: string) {
        if (unrecognizedPermissionsHash.hasOwnProperty(permissionName)) {
            delete unrecognizedPermissionsHash[permissionName]
        }
    }
}

const makeDatasetManagementNode = (screenDefinition: IDatasetManagementScreenDefinition): IAppNavigationUIRoute => {
    return {
        id: computeRoute(screenDefinition),
        title: screenDefinition.title,
        path: computePath(screenDefinition),
        component: screenDefinition.component,
        clickedAction: screenDefinition.clickedAction
    }
}

const computeRoute = (screenDefinition: IDatasetManagementScreenDefinition): string => {
    return `route_${pascalize(screenDefinition.title)}`
}

const computePath = (screenDefinition: IDatasetManagementScreenDefinition): string => {
    return `/DatasetManagement_${pascalize(screenDefinition.title)}`
}
